import React, { useEffect } from 'react'
import styles from './style.module.scss'
import Navbar from '../../Components/Navbar'
import { HeaderImg } from '../../Components/Header'
import headerImg from '../../Assets/headerImgs/abd.jpg'
import { Helmet } from 'react-helmet'

import fleetImg1 from '../../Assets/fleet-details/1-1-1.jpg'
import fleetImg2 from '../../Assets/fleet-details/1-2.jpg'
import fleetImg3 from '../../Assets/fleet-details/1-3.jpg'
import fleetImg4 from '../../Assets/fleet-details/1-4.jpg'

import fleetTechnology1 from '../../Assets/headerImgs/feature1.png'
import fleetTechnology2 from '../../Assets/headerImgs/feature2.png'
import fleetTechnology3 from '../../Assets/headerImgs/feature3.png'
import fleetTechnology4 from '../../Assets/fleet-details/tail-loader.jpg'
import fleetTechnology5 from '../../Assets/fleet-details/small-truck.jpg'

import Copyrights from '../../Components/Copyrights'
import 'aos/dist/aos.css';
import Aos from 'aos'

const FleetDetailsPage = () => {

	useEffect(() => {
    Aos.init({
      duration: 1000
    })
  }, [])

	return (
		<div className={styles.container}>
			<Helmet>
				<title>Fleet Details</title>
			</Helmet>
			<Navbar active="fleet-details" />
			{/* FleetDetailsPage */}
			<HeaderImg img={headerImg} />
			<div className={styles.fleetDetailsCont}>
				<div className={styles.fleetDetailsImgCont}>
					<img src={fleetImg1} alt="fleetImg1" data-aos="fade-up" />
					<img src={fleetImg2} alt="fleetImg2" data-aos="fade-up" data-aos-delay="100"/>
					<img src={fleetImg3} alt="fleetImg3" data-aos="fade-up" />
					<img src={fleetImg4} alt="fleetImg4" data-aos="fade-up" data-aos-delay="100"/>
				</div>
				<p>Our prestigious fleet has grown over the years into providing a well-established service to the market. We have refrigerated trucks catering to different requirements to clients with the ability to cater to any current demand in our ever-growing customer base.</p>
				<br />
				<p>The refrigerated trucks can carry cargo from small quantities to large quantities depending on the customer requirements and the accessibility of the destination. Our trucks are maintained carefully according to SLSI standards while ensuring regularly calibrated temperature controls by well trained staff.</p>
				<br />
				<h3>The Fleet</h3>
				<br />
				<p>We have our own fleet of ISUZU trucks equipped with regularly calibrated temperature controllers and rich with modern trends such as GPS navigation and are operated by well experienced well trained drivers and support staff.</p>
				<br />
				<p>To ensure the different needs of our customers we can provide our customers with five different sizes</p>
				<br />
				<p>10.5” feet</p>
				<p>14.5” feet</p>
				<p>16.5” feet</p>
				<p>18.5” feet</p>
				<p>20.0” feet</p>
				<h2>MAINTENANCE  & BREAKDOWN REPAIR TEAM</h2>
				<br />
				<p>Since our first priority is ensuring the safety of our trucks and the goods that we transport for our customers. We have setup a well-prepared team to handle tough and unexpected situations to handle breakdowns and repairs of our valued vehicles. In addition, we have kept a store of spare parts for the maintenance and repair of our refrigerated trucks.</p>
				<h2>OUR TECHNOLOGY</h2>
				<div className={styles.technologyCont} data-aos="fade-up">
					<img src={fleetTechnology1} alt="fleetTechnology1" />
					<p><span>Online temperature monitoring -</span>We provide solutions of temperature monitoring to our customers at the freedom by allowing them to track the temperature of the refrigerated trucks in real time.</p>
				</div>
				<div className={styles.technologyCont} data-aos="fade-up">
					<img src={fleetTechnology2} alt="fleetTechnology2" />
					<p><span>GPS tracking - </span>This technology is currently well-known which broadly means global positioning system. This technology included in our trucks allow real time tracking of the vehicle from anywhere in Sri Lanka by us and the customers on their preferred devices.</p>
				</div>
				<div className={styles.technologyCont} data-aos="fade-up">
					<img src={fleetTechnology3} alt="fleetTechnology3" />
					<p><span>Double compartment trucks - </span>We provide solutions of temperature monitoring to our customers at the freedom by allowing them to track the temperature of the refrigerated trucks in real time.</p>
				</div>
				<p style={{ marginBottom: '40px' }}><span>We have mobile cool room trucks which you can use as a cool room by plugging into AC or DC power</span></p>
				<div className={styles.technologyCont} data-aos="fade-up">
					<img src={fleetTechnology4} alt="fleetTechnology4" />
					<p><span>Tail lift power door -</span>It is a platform powered by hydraulics which is used to make loading or unloading of goods easier.</p>
				</div>
				<h2>FOR SMALL SCALE ENTERPRISES</h2>
				<div className={styles.technologyCont} data-aos="fade-up">
					<img src={fleetTechnology5} alt="fleetTechnology5" />
					<p>We have 6.5' Small trucks to match with the requirements of small scale customers</p>
				</div>
				<h2>FOR YOUR ASSURANCE</h2>
				<br/>
				<ul>
					<li><p>We allow for any check-ups from our customers side in order to ensure them on our quality</p></li>
					<li><p>We are ready to supply backup trucks very quickly on any emergency</p></li>
					<li><p>Your Goods and trucks are fully insured</p></li>
					<li><p>As a maintenance task we regularly sell old vehicles and replace with new one</p></li>
				</ul>
				<h2>COMING SOON</h2>
				<br />
				<p><span>Eutectic plates for trucks - </span>Eutectic plates are widely used in refrigerated vehicles to keep the temperature of the container in desired range, eliminating or including the refrigeration unit. Eutectic is a phase change material which remains unaffected by cyclic heating and cooling.</p>
			</div>
			<Copyrights />
		</div>
	)
}

export default FleetDetailsPage